module.exports = __webpack_public_path__ + "./images/10d561512c61d7959851dc8d0fd3ae19.webp";